import React from 'react';

const PageTitle = ({ title }) => {
    return title ?
        <h1>
            {title}
        </h1>
        : null;
};


export default PageTitle;